/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Alt_T_Acrobat_BestInputs */

const en_pc_alt_t_acrobat_best = /** @type {(inputs: Pc_Alt_T_Acrobat_BestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Editing existing text, Office conversion, e-signatures, multilingual OCR`)
};

const zh_pc_alt_t_acrobat_best = /** @type {(inputs: Pc_Alt_T_Acrobat_BestInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`编辑已有文字、Office 转换、电子签名、多语言 OCR`)
};

/**
* | output |
* | --- |
* | "Editing existing text, Office conversion, e-signatures, multilingual OCR" |
*
* @param {Pc_Alt_T_Acrobat_BestInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_alt_t_acrobat_best = /** @type {((inputs?: Pc_Alt_T_Acrobat_BestInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Alt_T_Acrobat_BestInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_alt_t_acrobat_best(inputs)
	return zh_pc_alt_t_acrobat_best(inputs)
});
export { pc_alt_t_acrobat_best as "pc.alt.t.acrobat.best" }